import { Navigate, Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Alert, Button, Spin } from 'antd';
import AssetManagerService, { getAssetManagerErrorMessage } from '../../../services/AssetManager/assetManager.service';
import { assetManagerServiceMessages } from '../../../services/AssetManager/assetManager.constants';
import { AppRoutes } from '../../../routes/routeConstants/appRoutes';
import { useAuth } from '../../../context/AuthContext';
import styles from './assetManagerGuard.module.scss';

// Layout route guard: Work Orders, Contacts and Asset Overview open only for clients with the Asset Manager add-on.
const AssetManagerGuard = () => {
  const { selectedClient } = useAuth();
  const { getStatus } = AssetManagerService();
  const { data: status, isLoading: isLoadingStatus, error, refetch } = useQuery(getStatus(selectedClient?.id));

  const handleRetry = () => void refetch();

  if (isLoadingStatus) return <Spin fullscreen />;
  // A failed background re-check keeps the last status, so a blip never ejects the user.
  if (!status) {
    return (
      <Alert
        className={styles.guardError}
        type="error"
        showIcon
        message={assetManagerServiceMessages.STATUS.GET_ERROR}
        description={
          <div>
            <p className={styles.guardErrorLine}>{getAssetManagerErrorMessage(error)}</p>
            <Button type="primary" onClick={handleRetry}>
              Retry
            </Button>
          </div>
        }
      />
    );
  }
  return status.enabled ? <Outlet /> : <Navigate to={AppRoutes.HOME} replace />;
};

export default AssetManagerGuard;
